module.exports = __webpack_public_path__ + "img/ludi-events.73d6b2e3.png";